<template>
    <div>
        <div class="modal-overlay active"  @click="closeDialog()"></div>
        <div class="modal">
            <div class="modal__header">
                <h2 id="emailModalTitle" class="headline-s">Receive an Email When It's in Stock</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div id="emailModalBody" class="modal__body flex-column">
                <div class="input-folder">
                    <div class="input-folder--input">
                        <input :aria-required="true" type="text" id="emailInput" v-model="form.email" placeholder=" " required>
                        <label for="emailInput">
                            <p class="paragraph-default">Email *</p>
                        </label>
                    </div>
                    <div class="input-folder--support">
                        <p class="input-suport-text invalid-state" v-if="form.errors.email"> {{ form.errors.email }}</p>
                    </div>
                </div>
                <Recaptcha v-if="!isLoggedIn" ref="recaptcha" v-model="captchaResponse" theme="light" />
                <RothcoCta id="submitButton" :class="formValid ? `primary` : `disabled`" :disabled="form.processing" @click="submit">Sign Up To Get Notified</RothcoCta>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { reactive, computed, inject, ref } from "vue";
    // import { route } from "ziggy-js";
    import Recaptcha from "@/components/Recaptcha.vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { useForm } from "@/helpers/composables/useForm";
    import { useSettingsStore } from "@/store/settings";
    import { storeToRefs } from "pinia";
    import { object, string, number} from 'yup';
    import CloseIcon from "@icons/closeIcon.svg";
    
    let settings = useSettingsStore();
    let { setNotificationMessage } = settings;
    let { user } = storeToRefs(settings);


    const dialogRef = inject('dialogRef');

    const closeDialog = () => {
        dialogRef?.value?.close();
    }

    const itemVariationId = dialogRef?.value?.data?.itemVariationId ?? null;
    let recaptcha = ref();

    const form = useForm({
        useInertia: false,
        schema: object({
            email: string().email('Must be a valid email').required("Email is required.")
                .default(user?.value?.email ?? ''),
        })
    });

    let isLoggedIn = computed(() => {
        return user.value?.user_id != null;
    });

    let captchaValid = computed(() => {
        if(isLoggedIn.value){
            return true;
        }
        return captchaResponse.value != null && captchaResponse.value != "";
    });
    const formValid = computed(() => {
        return !form.errors.email && captchaValid.value;
    });
    const submit = async function () {
        if(form.processing) return;
        await form.validate({all: true});
        if(formValid.value){
            form.post(route("products.instock_email"), {
                instock_email: form.transform((data)=>({
                    email: data.email,
                    item_variation_id: itemVariationId
                }))
            }, {
                afterFetch(ctx){
                    dialogRef?.value?.close();
                    settings.setNotificationMessage({
                        message: `You're all set! We'll notify you via email as soon as this product is in stock.`,
                        type: 'success'
                    })
                },
                onFetchError(ctx){
                    dialogRef?.value?.close();
                    settings.setNotificationMessage({
                        message: `There was an issue with your request, please try again.`,
                        type: 'error'
                    })
                }
            })
        }
    };
    let captchaResponse = ref();
</script>
